import React, { useEffect, useState, useMemo } from "react";
import CustomDatatableGrid from "../../components/CustomDatatableGrid";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { get } from "../../services/api";
import Select from "react-select";
import logo from "../../assets/img/logo-full.png";

const UserReport = () => {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId = localStorage.getItem("centerId");

  const [centersData, setCentersData] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCenters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedCenter) {
      if (selectedCenter.value) {
        fetchReport(selectedCenter.value);
      }
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCenter]);

  const fetchCenters = async () => {
    try {
      const response = await get(
        `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const options = response.map((c) => ({ value: c.id, label: c.name }));
      setCentersData(options);

      if (savedCenterId && savedCenterId !== "0" && savedCenterId !== "null") {
        const found = options.find((c) => c.value == savedCenterId);
        if (found) {
             setSelectedCenter(found);
        }
      }
    } catch (error) {
      console.error("Error fetching centers:", error);
    }
  };

  const fetchReport = async (centerId) => {
    if (!centerId) return;
    setLoading(true);
    try {
        // Updated API path as per request: Student/GetStudentCredentialsReport
      const response = await get(
        `Student/GetStudentCredentialsReport?centerId=${centerId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response && response.isSuccess) {
        setReportData(response.data || []);
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
      setReportData([]);
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "sr",
        header: "Sr No.",
        size: 60,
      },
      {
        accessorKey: "parentName",
        header: "Parent Name",
      },
      {
        accessorKey: "parentUserName",
        header: "Parent Username",
      },
      {
        accessorKey: "parentPassword",
        header: "Parent Password",
      },
      {
        accessorKey: "studentName",
        header: "Student Name",
      },
      {
        accessorKey: "studentUserName",
        header: "Student Username",
      },
      {
        accessorKey: "studentPassword",
        header: "Student Password",
      },
    ],
    []
  );

  const exportToExcel = () => {
    const dataToExport = reportData.map((row) => ({
      "Sr No.": row.sr,
      "Parent Name": row.parentName,
      "Parent Username": row.parentUserName,
      "Parent Password": row.parentPassword,
      "Student Name": row.studentName,
      "Student Username": row.studentUserName,
      "Student Password": row.studentPassword,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "User Credentials");
    XLSX.writeFile(workbook, "UserCredentialsReport.xlsx");
  };

  const exportToPDF = async () => {
    const doc = new jsPDF("l", "mm", "a4"); // Landscape
    
    doc.setFontSize(14);
    doc.text("User Credentials Report", 14, 15);
    
    const headers = [["Sr No.", "Parent Name", "Parent Username", "Parent Password", "Student Name", "Student Username", "Student Password"]];
    const data = reportData.map(row => [
        row.sr,
        row.parentName,
        row.parentUserName,
        row.parentPassword,
        row.studentName,
        row.studentUserName,
        row.studentPassword
    ]);

    doc.autoTable({
      head: headers,
      body: data,
      startY: 20,
      theme: 'grid',
      styles: { fontSize: 8 },
      headStyles: { fillColor: [22, 163, 74] } // Greenish heading
    });

    doc.save("UserCredentialsReport.pdf");
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
         <h2 className="page-heading mb-2 fs-7">User Credentials Report</h2>
      </div>
      <div className="card">
        <div className="card-body">
            <div className="row mb-3 align-items-end">
                <div className="col-md-4">
                    <label className="form-label form-label-new">Center</label>
                    <Select
                        options={centersData}
                        value={selectedCenter}
                        onChange={(opt) => setSelectedCenter(opt)}
                        placeholder="Select Center"
                        isDisabled={savedCenterId && savedCenterId !== "0" && savedCenterId !== "null"}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                    />
                </div>
                <div className="col-md-8 text-end">
                    <button className="btn btn-success btn-sm me-2" onClick={exportToExcel} disabled={reportData.length === 0}>
                        <i className="fas fa-file-excel me-1"></i> Export Excel
                    </button>
                    <button className="btn btn-danger btn-sm" onClick={exportToPDF} disabled={reportData.length === 0}>
                        <i className="fas fa-file-pdf me-1"></i> Export PDF
                    </button>
                </div>
            </div>

            {loading ? (
                <div className="text-center py-5">Loading...</div>
            ) : (
                <CustomDatatableGrid
                    columns={columns}
                    data={reportData}
                    enableRowSelection={false}
                />
            )}
        </div>
      </div>
    </>
  );
};

export default UserReport;
